import React from "react";
import { Container, Grid } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { ProfileForm, BookmarkList } from "./../../";

export default function ProfilePage() {
	const theme = useTheme();
	let bookmarks_on = process.env.GATSBY_IS_BOOKMARK_PAGES_ENABLED;

	return (
		<main>
			<Container
				maxWidth={theme?.customOptions?.containerMaxWidth || "xl"}
				sx={{ padding: theme.spacing(3, 0) }}
			>
				<Grid container spacing={5} sx={{ justifyContent: "center" }}>
					<Grid item xs={bookmarks_on ? 3 : 6}>
						<ProfileForm />
					</Grid>
					{bookmarks_on && (
						<Grid item xs={9}>
							<BookmarkList />
						</Grid>
					)}
				</Grid>
			</Container>
		</main>
	);
}
